import inRange from 'lodash/inRange'
import maxBy from 'lodash/maxBy'
import unionBy from 'lodash/unionBy'
import api from '@/api'
import { PLACEMENT_STATUSES, NOT_PROPOSED } from '../constants'
import { sortedPlacements, buildPlacement } from '../helpers'

export const getters = {
  consultantsEligibleForStaffingRole() {
    return (staffingRole) => {
      const ACCEPTABLE_TIER_DELTA = 1
      const lowerBound = staffingRole.tier - ACCEPTABLE_TIER_DELTA
      const upperBoundInclusive = staffingRole.tier + ACCEPTABLE_TIER_DELTA + 1
      return this.consultantsWithNextAvailableDate.filter(
        (consultant) =>
          !(consultant.percentageUtilization === 0) &&
          inRange(consultant.tier, lowerBound, upperBoundInclusive)
      )
    }
  },

  getPlacementsForStaffingRole: (state) => (staffingRoleId) =>
    state.placements.filter((placement) => placement.staffingRoleId === staffingRoleId),

  getPlacedUsersForStaffingRole() {
    return (staffingRole) => {
      const placements = this.getPlacementsForStaffingRole(staffingRole.id)
      const placedUserIds = placements.map(({ userId }) => userId)
      let users = []
      for (const id in this.users) {
        const user = this.users[id]
        if (placedUserIds.includes(parseInt(id))) {
          users = [...users, user]
        }
      }
      return users
    }
  },

  getMostAdvancedPlacementStatusForStaffingRole() {
    return (staffingRole) => {
      if (!staffingRole || !staffingRole.id) return PLACEMENT_STATUSES[0]
      const placements = this.getPlacementsForStaffingRole(staffingRole.id)
      return placements.length > 0
        ? maxBy(placements, (placement) => PLACEMENT_STATUSES.indexOf(placement.status)).status
        : PLACEMENT_STATUSES[0]
    }
  },

  buildAllPossiblePlacementsForStaffingRole() {
    return (staffingRole) => {
      const eligibleConsultants = this.consultantsEligibleForStaffingRole(staffingRole)
      const allPlacementsForStaffingRole = this.getPlacementsForStaffingRole(staffingRole.id)
      const notProposedPlacements = eligibleConsultants.map((consultant) =>
        buildPlacement(null, staffingRole.id, NOT_PROPOSED, consultant)
      )
      const persistedPlacements = allPlacementsForStaffingRole
        .map((placement) => {
          const user = this.users[placement.userId]
          return buildPlacement(placement.id, staffingRole.id, placement.status, user)
        })
        .filter((placement) => !!placement)
      return sortedPlacements(unionBy(persistedPlacements, notProposedPlacements, 'userId'))
    }
  },
}

export const actions = {
  async fetchPlacements() {
    this.placements = await api.fetchPlacements()
  },
}
